import React from "react";

import About from "../components/About";
// import GameCards from "../components/GameCard";
import PageInner from "../components/PageInner";
// import VideoBanner from "../components/VideoBanner";
// import EverestStory from "../components/EverestStory";
// import EverestExpedition from "../components/EverestExpendition";
import BannerCarousel from "../components/BannerCarousel";
import '../App.css'; // Ensure to import your CSS
// import Header from "./components/Header";
import HistoryCarousel from "../components/HistoryExpedition";
import Peak from "../components/heighestPeak"
import Places from "../components/ImportantPlace"
import Altitude from "../components/AltitudeHigh"

function HomePage() {
  return (
    <div>
     
      {/* <VideoBanner/> */}
      <BannerCarousel/>
      <HistoryCarousel/>
      <br/>
      <About />
     <PageInner/>
     {/* <EverestStory/> */}
     <Peak/>
     <Places/>
     <Altitude/>
      {/* <GameCards /> */}
    
    </div>
  );
}

export default HomePage;
